/**
 * Analytics tracking helpers for subscription events
 */

/**
 * Track an analytics event
 * @param {string} eventName - Event name
 * @param {Object} properties - Event properties
 */
export function trackEvent(eventName, properties = {}) {
  try {
    // Log to console in development
    if (process.env.NODE_ENV === 'development') {
      console.log('[Analytics]', eventName, properties);
    }

    // Send to analytics service if available
    // This can be extended with Google Analytics, Mixpanel, etc.
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', eventName, properties);
    }
  } catch (error) {
    console.error('analytics:trackEvent failed', error);
  }
}

/**
 * Track upgrade modal shown event
 * @param {Object} context - Context information (limit, topic, etc.)
 */
export function trackUpgradeShown(context = {}) {
  trackEvent('upgrade_shown', {
    category: 'subscription',
    ...context
  });
}

/**
 * Track upgrade button clicked event
 * @param {Object} context - Context information
 */
export function trackUpgradeClicked(context = {}) {
  trackEvent('upgrade_clicked', {
    category: 'subscription',
    ...context
  });
}

/**
 * Track checkout started event
 * @param {string} priceId - Stripe price ID
 */
export function trackCheckoutStarted(priceId = null) {
  trackEvent('checkout_started', {
    category: 'subscription',
    price_id: priceId
  });
}

/**
 * Track checkout failed event
 * @param {string} error - Error message
 */
export function trackCheckoutFailed(error) {
  trackEvent('checkout_failed', {
    category: 'subscription',
    error: error
  });
}

/**
 * Track manage subscription clicked event
 */
export function trackManageSubscriptionClicked() {
  trackEvent('manage_subscription_clicked', {
    category: 'subscription'
  });
}

/**
 * Track dismiss upgrade modal event
 * @param {Object} context - Context information
 */
export function trackUpgradeDismissed(context = {}) {
  trackEvent('upgrade_dismissed', {
    category: 'subscription',
    ...context
  });
}
